/**
 * 登录相关工具
 */

import { logout } from '@/api/login'
import { removeToken } from '@/utils/auth'
import router from '@/router'

// 登出操作
export async function client_logout() {
  let res = await logout()
  if (res.code === 200) {
    removeToken()
    setTimeout(() => {
        router.push({name: 'wxLogin'});
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/utils/login.js